import styled from 'styled-components';

export const HowitWorksWrapper = styled.div(
	({ colorTheme, theme: { down, breakpoints } }) => `
  position: relative;
  background: ${colorTheme === 'light' ? 'transparent' : '#0B1A2F'};
  padding: 80px 0;
  ${down(breakpoints.md)} {
    padding: 100px 0 20px 16px;
  }
`
);

export const HowitWorksCurve = styled.div(
	({ theme: { down, breakpoints } }) => `
  width: calc(100% * 1.4);
  height: 170px;
  background: #fff;
  border-radius: 50% / 150px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  position: absolute;
  left: 50%;
  top: -122px;
  z-index: 2;
  transform: translateX(-50%);
  ${down(breakpoints.md)} {
    width: calc(100% * 2);
  }
    
  `
);

export const HowItWorksList = styled.ul(
	({ theme: { down, breakpoints } }) => `
  display:flex;
  justify-content: space-between;
  padding-top: 25px;
  ${down(breakpoints.md)} {
    overflow-y: scroll;
  }
  li{
    width: 30%;
      ${down(breakpoints.md)} {
       min-width:207px;
       margin-right: 30px;
      }
  }
`
);

export const CircularWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
    width:80px;
    height:80px;
    border-radius:50%;
    flex-shrink:0;
    display:flex;
    background-color: white;
    align-items:center;
    justify-content:center;
    font-size:48px;
    color:#F76162;
    position: absolute;
    top:-39px;
    left:72px;
    font-weight:bold;
    ${down(breakpoints.md)} {
      width:45px;
      height:45px;
      font-size:20px;
      left:40px;
      top:-20px;
    }
`
);
